import _typeof from "@babel/runtime/helpers/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { calculate } from "./math";

/**
 * 执行波段计算 format + operation
 * @param imageDataList 
 * @param rasterFormat 
 * @param operation 
 * @returns 
 */
export function bandsOperation(_x, _x2, _x3) {
  return _bandsOperation.apply(this, arguments);
}

function _bandsOperation() {
  _bandsOperation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(imageDataList, rasterFormat, operation) {
    var bandsData, _bandsData$, width, height, rasterData, channelR, channelG, channelB, rgbBands, _combineRGBChannels, data, channelRMax, channelGMax, channelBMax;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(imageDataList.length === 0)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", {
              rasterData: [0],
              width: 1,
              heigh: 1
            });

          case 2:
            _context.next = 4;
            return Promise.all(imageDataList.map(function (_ref) {
              var data = _ref.data,
                  _ref$bands = _ref.bands,
                  bands = _ref$bands === void 0 ? [0] : _ref$bands;
              return rasterFormat(data, bands);
            }));

          case 4:
            bandsData = _context.sent;
            // @ts-ignore 
            bandsData = bandsData.flat(); // Tip: rasterFormat 返回值 rasterData|rasterData[]
            // 多个栅格数据必须是相同大小才能进行相互之间的运算

            _bandsData$ = bandsData[0], width = _bandsData$.width, height = _bandsData$.height;
            channelR = undefined;
            channelG = undefined;
            channelB = undefined;
            _context.t0 = _typeof(operation);
            _context.next = _context.t0 === 'function' ? 13 : _context.t0 === 'object' ? 15 : 17;
            break;

          case 13:
            rasterData = operation(bandsData);
            return _context.abrupt("break", 18);

          case 15:
            // 波段计算表达式 - operation
            // operation: ['+', ['band', 0], 1]

            /**
             * operation: {
             *  r: ['+', ['band', 0], 1],
             *  g: ['+', ['band', 0], 1],
             *  b: ['+', ['band', 0], 1],
             * }
             */
            if (!Array.isArray(operation)) {
              rgbBands = getRgbBands(operation, bandsData);
              _combineRGBChannels = combineRGBChannels(rgbBands), data = _combineRGBChannels.data, channelRMax = _combineRGBChannels.channelRMax, channelGMax = _combineRGBChannels.channelGMax, channelBMax = _combineRGBChannels.channelBMax;
              rasterData = data;
              channelR = channelRMax;
              channelG = channelGMax;
              channelB = channelBMax;
            } else {
              rasterData = calculate(operation, bandsData);
            }

            return _context.abrupt("break", 18);

          case 17:
            rasterData = bandsData[0].rasterData;

          case 18:
            return _context.abrupt("return", {
              rasterData: rasterData,
              width: width,
              height: height,
              channelR: channelR,
              channelG: channelG,
              channelB: channelB
            });

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _bandsOperation.apply(this, arguments);
}

function getRgbBands(operation, bandsData) {
  if (operation.r === undefined) console.warn('Channel R lost in Operation! Use band[0] to fill!');
  if (operation.g === undefined) console.warn('Channel G lost in Operation! Use band[0] to fill!');
  if (operation.b === undefined) console.warn('Channel B lost in Operation! Use band[0] to fill!');
  var r = calculate(operation.r || ['band', 0], bandsData);
  var g = calculate(operation.g || ['band', 0], bandsData);
  var b = calculate(operation.b || ['band', 0], bandsData);
  return [r, g, b];
}
/**
 * 将波段数据进行合并操作（彩色多通道）
 * @param bandsData 
 */


function combineRGBChannels(bandsData) {
  var channelR = bandsData[0];
  var channelG = bandsData[1];
  var channelB = bandsData[2];
  var data = [];
  var channelRMax = -Infinity;
  var channelGMax = -Infinity;
  var channelBMax = -Infinity;

  for (var i = 0; i < channelR.length; i++) {
    data.push(channelR[i]);
    channelRMax = Math.max(channelRMax, channelR[i]);
    data.push(channelG[i]);
    channelGMax = Math.max(channelGMax, channelR[i]);
    data.push(channelB[i]);
    channelBMax = Math.max(channelBMax, channelR[i]);
  }

  return {
    data: data,
    channelRMax: channelRMax,
    channelGMax: channelGMax,
    channelBMax: channelBMax
  };
}
/**
 * 处理每个请求得到的栅格文件数据
 */


export function handleRasterFiles(_x4, _x5, _x6, _x7) {
  return _handleRasterFiles.apply(this, arguments);
}

function _handleRasterFiles() {
  _handleRasterFiles = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(rasterFiles, rasterFormat, operation, callback) {
    var _yield$bandsOperation, rasterData, width, height, defaultMIN, defaultMAX;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return bandsOperation(rasterFiles, rasterFormat, operation);

          case 2:
            _yield$bandsOperation = _context2.sent;
            rasterData = _yield$bandsOperation.rasterData;
            width = _yield$bandsOperation.width;
            height = _yield$bandsOperation.height;
            // 目前 max｜min 没有生效
            defaultMIN = 0;
            defaultMAX = 8000;
            callback(null, {
              data: rasterData,
              width: width,
              height: height,
              min: defaultMIN,
              max: defaultMAX
            });

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _handleRasterFiles.apply(this, arguments);
}